import axios, { AxiosPromise } from 'axios';

import { ConfiguracaoInscricaoCadastral } from '../type';

export const loadConfiguracao = (): AxiosPromise<ConfiguracaoInscricaoCadastral> =>
  axios.get('/api/inscricao-cadastral/configuracao');
